<template>
  <div class="flex-container">
    <div class="row">
      <div v-bind:class="getColNum()" v-if="isSuperAdmin || isAdmin">
        <button class="invert" id="btnUsers" v-if="isSuperAdmin" @click="showUsers()">
          Χρήστες
        </button>
        <button class="invert" id="btnParameters" v-if="isSuperAdmin" @click="showParameters">
          Παράμετροι Εφαρμογής
        </button>
        <button class="invert" id="btnVacations" v-if="isSuperAdmin || isAdmin" @click="showVacations">
          Αδράνειες
        </button>
        <button class="invert" id="btnAdminTools" v-if="isSuperAdmin" @click="showAdminTools">
          Admin Tools
        </button>

        <!-- show Organizations in left column if is admin (for visual reasons) -->
        <button class="invert" id="btnOrganizations" v-if="isAdmin" @click="showOrganizations">
          Φορείς
        </button>
      </div>
      <div v-bind:class="getColNum()">
        <!-- show Organizations in middle column if is superAdmin (for visual reasons) -->
        <button class="invert" id="btnOrganizations" v-if="isSuperAdmin" @click="showOrganizations">
          Φορείς
        </button>
        <button class="invert" id="btnStructures" v-if="isAuthenticated" @click="showStructures">
          Δομές
        </button>
        <button class="invert" id="btnOrganizationEmployees" v-if="isSuperAdmin || isAdmin || isRepresentative"
          @click="showOrganizationEmployees()">
          Χρήστες Φορέα
        </button>
        <button class="invert" id="btnStructures" v-if="isAuthenticated && hasFullAccess" @click="showContracts">
          Συμβάσεις
        </button>
        <button class="invert" id="btnStructures" v-if="isSuperAdmin" @click="showExternalConnectionProperties">
          Διασύνδεση Τρίτων Εφαρμογών
        </button>
      </div>
      <div v-bind:class="getColNum()">
        <button class="invert" id="btnAttendances" v-if="isAuthenticated && hasFullAccess" @click="showAttendances">
          Παρουσίες
        </button>
        <button v-if="hasFullAccess" class="invert" id="btnUsers" @click="showPayments">
          Πληρωμές
        </button>
        <button class="invert" id="btnMobiles" v-if="isSuperAdmin || isAdmin || isRepresentative" @click="showMobiles">
          Κινητές Συσκευές
        </button>
        <button :class="showNotification.isLastAnnouncementNotSeen ? 'invert notification green' : 'invert notification'" id="btnAnnouncements" v-if="isAuthenticated" @click="showAnnouncements">
          Ανακοινώσεις
          <span v-if="showNotification.count > 0" class="badge">{{ showNotification.count }}</span>
        </button>
        <button class="invert" id="btnAdminTools" v-if="isSuperAdmin || isAdmin || isUser || isRepresentative"
          @click="showVerifications">
          Επιβεβαίωση Παρουσιών
        </button>

      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import mainService from "../../services/mainService";

export default {
  data() {
    return {
      colNum: "col-md-4",
      showNotification: {
        count:0,
        isLastAnnouncementNotSeen: false
      },
    };
  },
  async mounted() {
    if(!this.$store.getters.isSuperAdmin && !this.$store.getters.isAdmin){
      var showNotificationForAnnouncements = await mainService.get('Announcements/ShowNotification?organizationId=' + this.organizationId);

      this.showNotification.count = showNotificationForAnnouncements.data.Count;
      this.showNotification.isLastAnnouncementNotSeen = showNotificationForAnnouncements.data.IsLastAnnouncementNotSeen;
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isRepresentative() {
      return this.$store.getters.isRepresentative;
    },
    isUser() {
      return this.$store.getters.isUser;
    },
    nickName() {
      return this.$store.getters.getNickName;
    },
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
    hasFullAccess() {
      return this.$store.getters.getHasFullAccess;
    },
    OrganizationEmployeeHasFullAccess() {
      var orgEmpHasFullAccess = this.$store.getters.getHasFullAccess;
      var hasFullAccess = orgEmpHasFullAccess.find(
        (x) => x.OrganizationId == this.organizationId
      );
      return hasFullAccess;
    },
  },
  watch: {
    organizationId: async function (newValue, oldValue) {
      const res = await mainService.get(
        `/structures/GetStructuresByUserAndOrganization?organizationId=${this.organizationId}`
      );
      this.structures = res.data;
    },
  },
  methods: {
    showAnnouncements(){
      router.replace("/Announcements/Index");
    },
    showOrganizations() {
      router.replace("/organizations");
    },
    showOrganizationEmployees() {
      router.replace("/organizationEmployees");
    },
    showUsers() {
      router.replace("/users");
    },
    showStructures() {
      router.replace("/structures");
    },
    showContracts() {
      router.replace("/contracts");
    },
    showVacations() {
      router.replace("/vacations");
    },
    showAttendances() {
      router.replace("/attendances");
    },
    showPayments() {
      router.replace("/payments");
    },
    showAdminTools() {
      router.replace("/adminTools");
    },
    showParameters() {
      router.replace("/parameters");
    },
    showMobiles() {
      router.replace("/mobiles");
    },
    showVerifications() {
      router.replace("/verfications");
    },
    showExternalConnectionProperties() {
      router.replace("/authenticateApps");
    },
    getColNum() {
      if (!(this.isSuperAdmin || this.isAdmin)) {
        return "col-md-6";
      } else {
        return "col-md-4";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-container {
  padding: 3rem 2rem;
}
.notification{
  position: relative;
  overflow: unset;

  .badge{
    position: absolute;
    top: -7px;
    right: -7px;
    padding: 10px 11px;
    border-radius: 50%;
    background: rgb(250, 44, 44);
    color: white;
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.452);
  }

}
.green{
    background: linear-gradient(to bottom right, #cdd9ed, #448626) !important;
}
</style>

